/* ========================================================================
   神戸リボン LINE のトークを 1 通ずつ届ける（kr-lchat-play）— LChat.play(トーク, 設定)
   - トーク（ol.lchat__talk など）の子要素（日付・行）を上から順に出す。受信の前には「入力中…」の点が揺れる
   - 隠すのは、このスクリプトが付ける属性（data-lchat-row など）だけ。見た目は assets/kr-motion.css の「4. LINE のトーク」。
     JS が動かない・遅いとき、テーマ設定「動きの演出」がオフ（このファイルを読み込まない）ときは、最初から全部見えている
   - 守ること
     ・読み込んだ時点で画面に見えている行（#付きのリンクで着いた先の 1 画面を含む）は隠さない。
       再読み込み・戻る／進むで開いたとき（ブラウザが前の位置までスクロールを戻す）は、どのトークも隠さない
     ・端末の「動きを減らす」、テーマエディタ内、IntersectionObserver のない古いブラウザ、data-lchat-static の付いた
       トークでは何もしない（全部見えたまま）
     ・行の場所は最初から決まっている（動かすのは opacity と transform だけ。「入力中…」も場所を取らない）
     ・最初に見えた 1 画面ぶんは、ふつうの速さで 1 通ずつ出す。ただし 1 回の再生（見えている行を続けて出す間）は
       最大 runCapMs（4.5 秒）。それを過ぎたら、見えている行を全部出して止まる（5 秒を超えて動き続けない）
     ・再生が始まってから見えてきた行、上へ通り過ぎたあと画面に残った行は、最大 catchUpMs（2.5 秒）待たせるまで。
       画面より高いトークでは maxWaitMs（1.4 秒。同時に見えた行は、1 行ごとに tallStepMs ずつ後ろへ）
     ・期限の来た行は、「入力中…」を出さずに catchStepMs（0.3 秒）ずつ順に出す（何行もいっぺんには出さない）
     ・画面の下 12% から上に来られない行（ページの最後など）も、edgeMs（1.2 秒）たったら見えたことにして順番に並べる。
       期限を付けるのは画面より高いトークだけ（すでに待っている行のあとへ、tallStepMs ずつずらす）
     ・続けて届く受信の 2 通目からは「入力中…」を出さない（少し間をあけて出す）
     ・スクロールで通り過ぎた行、トーク自身の枠で切れて見えない行は、待たずにすぐ出す
     ・トークをクリック・タップした・キーボードでトークの中に移った・印刷する・タブを切り替えた・ページを離れた・
       「動きを減らす」をオンにした、のどれでも、その場で全部出す
     ・閉じた <details> の中のトークは、開いたときに再生する（途中で閉じたら止め、開き直したら続きから）
     ・トークをページから外したら、黙って止まる（タイマーや監視を残さない）
   - 使い方
       var ctl = LChat.play(トーク, 設定);   // → { replay(), revealAll(), destroy() }
       LChat.autoInit(root);                  // root（省略時はページ全体）の [data-lchat-auto] を presets.v9 で再生。
                                              // 読み込み時に 1 回自動で呼ぶ（再読み込み・戻る／進むのときは呼ばない）。
                                              // data-lchat-auto="krp" なら presets.krp
       LChat.viewBottom();                    // 「読み込んだ時点で見えている」とみなす下端（#付きのリンクで着いた先を含む）
       LChat.restored();                      // 再読み込み・戻る／進むで開いたか（そのときは読み込み時に何も伏せない）
     設定（省略可）
       immediate: true      画面に見えているかどうかを見ずに、全部の行を隠して最初の行から今すぐ再生する
                            （TOP の会話の切り替え用）。「動きを減らす」・テーマエディタ・古いブラウザでは全部をすぐ出す。
                            タブが裏にあるときに呼ばれたら、表に戻ったときに始める。runCapMs の上限はかけない
       from: 2              immediate のとき、この番号（0 から）より前の行（日付・最初の質問など）は隠さずに出しておき、
                            この行から再生する
       onDone: function(){} 全部の行が出たときに 1 回だけ呼ぶ。再生しないとき（上の「何もしない」場合や、全部見えていたとき）も
                            すぐに、revealAll() のあとも呼ぶ。destroy() のあと・トークを外したあとは呼ばない。
                            replay() で始め直すと、次に出し終えたときにまた 1 回
       そのほか（既定値は下の DEFAULTS）: 間の取り方と、行を見分けるセレクタ（inRow を渡すと presets.v9 は混ぜない）
     中身を入れ替えるときは、先に ctl.destroy() を呼ぶ（同じ要素にもう一度 play() しても、前の再生は自動で止まる）
   - テーマエディタ内と「動きの演出」オフでは、snippets/kr-motion.liquid がこのファイルを読み込まない。
     使う側は window.LChat がなくても動くように書く（全部見せる・すぐ切り替える）
   ======================================================================== */
(function () {
  'use strict';
  var W = window, D = document;
  if (W.LChat) return;

  var DEFAULTS = {
    startDelay: 250, gapOut: 300, gapOutCont: 200, gapInCont: 300, gapPlain: 150, readPause: 200,
    typePerChar: 20, typeMin: 600, typeMax: 1100, contFactor: 0.7, jitter: 0.1,
    catchUpMs: 2500, maxWaitMs: 1400, tallStepMs: 900, edgeMs: 1200, tallRatio: 0.9,
    catchStepMs: 300, runCapMs: 4500,
    rootMargin: '0px 0px -12% 0px', dur: 360, batchMs: 1000,
    inRow: null, outRow: null, contRow: null, contChild: null,
    anchors: [], body: null, avatar: null, meta: null,
    immediate: false, from: 0, onDone: null
  };
  var PRESETS = {
    v9: { inRow: '.lchat__row--in', outRow: '.lchat__row--out', contRow: '.lchat__row--cont', contChild: null,
          anchors: ['.lchat__bubble', '.lchat__photo', '.lchat__body'], body: '.lchat__body',
          avatar: '.lchat__avatar', meta: '.lchat__meta' },
    krp: { inRow: '.krp-msg--in', outRow: '.krp-msg--out', contRow: null, contChild: '.krp-msg__avatar--blank',
           anchors: ['.krp-msg__bubble', '.krp-msg__photo', '.krp-msg__file', '.krp-flex-row', '.krp-msg__body'],
           body: '.krp-msg__body', avatar: '.krp-msg__avatar:not(.krp-msg__avatar--blank)', meta: '.krp-msg__meta',
           gapOut: 300, readPause: 200, typeMax: 1100 }
  };
  var ROW = 'data-lchat-row', META = 'data-lchat-meta', INSTANT = 'data-lchat-instant', TYP = 'data-lchat-typing';
  var mq = W.matchMedia ? W.matchMedia('(prefers-reduced-motion: reduce)') : null;
  /* 行を隠している（または始まるのを待っている）トークだけを入れておく。出し終えたら外すので、
     destroy() を呼ばずに捨てられたトークがあっても、ここに残り続けない */
  var live = [];

  function reduced() { return !!(mq && mq.matches); }
  function now() { return W.performance ? W.performance.now() : Date.now(); }
  function is(el, sel) { return !!sel && el.matches(sel); }
  function has(el, sel) { return !!sel && !!el.querySelector(sel); }
  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }
  function txt(el) { return el ? el.textContent.replace(/\s+/g, '').length : 0; }
  function boxed(b) { return !!(b.width || b.height); }
  function rowsOf(c) {
    var out = [], ch = c.children;
    for (var i = 0; i < ch.length; i++) {
      var el = ch[i];
      if (/^(SCRIPT|TEMPLATE|STYLE)$/.test(el.tagName)) continue;
      if (el.classList.contains('lchat-typing') || el.classList.contains('lchat__sr')) continue;
      out.push(el);
    }
    return out;
  }
  function off(c) {
    return reduced() || !('IntersectionObserver' in W) || c.hasAttribute('data-lchat-static') ||
      D.documentElement.classList.contains('shopify-design-mode');
  }
  /* #付きのリンクで開いたときは、着いた先の 1 画面ぶんとそれより上を「見えている」とみなす */
  function viewBottom() {
    var vh = W.innerHeight || D.documentElement.clientHeight, el = null;
    try { el = location.hash.length > 1 ? D.getElementById(decodeURIComponent(location.hash.slice(1))) : null; } catch (e) {}
    return el ? Math.max(vh, el.getBoundingClientRect().top + vh) : vh;
  }
  /* 再読み込み・戻る／進むで開いた: ブラウザが前に見ていた位置までスクロールを戻すので、読み込み時点では
     どの行が画面に来るか分からない（見ていた会話を伏せて、もう一度流さないように、自動の再生はしない） */
  function restored() {
    try {
      var nav = W.performance && performance.getEntriesByType ? performance.getEntriesByType('navigation')[0] : null;
      var auto = !W.history || !history.scrollRestoration || history.scrollRestoration === 'auto';
      return !!nav && (nav.type === 'reload' || nav.type === 'back_forward') && auto;
    } catch (e) { return false; }
  }
  function css(el, s) { for (var k in s) el.style[k] = s[k]; }
  function each(name) {
    var list = live.slice();
    for (var i = 0; i < list.length; i++) list[i][name]();
  }
  /* 吹き出しの中の「神戸リボン：」「お客様：」（読み上げ用）の文字数 */
  function srLen(el) {
    var n = 0, s = el ? el.querySelectorAll('.lchat__sr') : [];
    for (var i = 0; i < s.length; i++) n += txt(s[i]);
    return n;
  }

  /* ページ全体で 1 回だけ付ける（トークごとに window へ付けると、捨てたトークの分が残る） */
  function onMq() {
    if (reduced()) each('reveal');
    var bs = D.querySelectorAll('button[data-lchat-replay]');
    for (var i = 0; i < bs.length; i++) {
      var t = D.getElementById(bs[i].getAttribute('data-lchat-replay'));
      if (t && t._lchat) bs[i].hidden = reduced();
    }
  }
  W.addEventListener('beforeprint', function () { each('reveal'); });
  /* ページを離れるとき（戻るボタンで復元されるときも、全部出た状態で戻る） */
  W.addEventListener('pagehide', function () { each('reveal'); });
  D.addEventListener('visibilitychange', function () { each(D.hidden ? 'reveal' : 'wake'); });
  if (mq) { if (mq.addEventListener) mq.addEventListener('change', onMq); else if (mq.addListener) mq.addListener(onMq); }
  /* 画面の向き・幅が変わった: 再生中のトークの大きさを測り直し、出ている「入力中…」を置き直す */
  var resizeT = 0;
  W.addEventListener('resize', function () {
    clearTimeout(resizeT);
    resizeT = setTimeout(function () { each('relayout'); }, 150);
  });

  function play(c, opts) {
    var o = {}, k, base = opts && opts.inRow ? null : PRESETS.v9;
    for (k in DEFAULTS) o[k] = DEFAULTS[k];
    if (base) for (k in base) o[k] = base[k];
    if (opts) for (k in opts) if (opts[k] !== undefined) o[k] = opts[k];
    var el = c && c.nodeType === 1 ? c : null;
    if (el && el._lchat) el._lchat.destroy();

    var rows = [], qi = 0, seen = new Map(), due = new Map(), edgeT = new Map();
    var io = null, io2 = null, stepT = 0, dueT = 0, endT = 0, doneT = 0, capT = 0, typing = null, gen = 0, colX = null;
    var active = false, busy = false, idle = true, started = false, hurry = 0, runStart = 0, tall = false, clips = false;
    var catchTo = -1, catching = false; /* この番号の行までは、期限が来た（またはその前の）行。点を出さずに順に出す */
    var held = false, waiting = null, reported = true, marked = false, posSet = false, dead = false;
    var details = [], buttons = [], ctl;

    /* onDone は次のタスクで呼ぶ（play() が controller を返す前に呼ばれないように）。destroy() で取り消す */
    function report() {
      clearTimeout(doneT);
      doneT = setTimeout(function () {
        doneT = 0;
        if (!dead && typeof o.onDone === 'function') o.onDone();
      }, 0);
    }

    /* 再生しない（動きを減らす・テーマエディタ・古いブラウザ・data-lchat-static）: 何も隠さず、すぐ「出し終えた」 */
    if (!el || off(el)) {
      ctl = {
        replay: function () { if (!dead) report(); },
        revealAll: function () {},
        destroy: function () {
          dead = true;
          clearTimeout(doneT);
          if (el && el._lchat === ctl) el._lchat = null;
        }
      };
      if (el) el._lchat = ctl;
      report();
      return ctl;
    }

    var runner = { reveal: revealAll, wake: wake, relayout: relayout };
    function track(on) {
      var i = live.indexOf(runner);
      if (on && i < 0) live.push(runner);
      else if (!on && i >= 0) live.splice(i, 1);
    }

    function pending(r) { return r.getAttribute(ROW) === 'pending'; }
    function kind(r) { return is(r, o.inRow) ? 'in' : is(r, o.outRow) ? 'out' : 'plain'; }
    function cont(r) { return is(r, o.contRow) || has(r, o.contChild); }
    function step(ms, fn) { var g = gen; clearTimeout(stepT); stepT = setTimeout(function () { if (g === gen) fn(); }, ms); }
    function shut() { for (var i = 0; i < details.length; i++) if (!details[i].open) return true; return false; }
    function gone() { return c.isConnected === false; }
    function anchor(r) {
      for (var i = 0; i < o.anchors.length; i++) { var a = r.querySelector(o.anchors[i]); if (a) return a; }
      return r;
    }
    function offsetIn(node) {
      var x = 0, y = 0, n = node;
      while (n && n !== c) { x += n.offsetLeft; y += n.offsetTop; n = n.offsetParent; }
      if (n === c) return [x, y];
      var a = node.getBoundingClientRect(), b = c.getBoundingClientRect();
      return [a.left - b.left - c.clientLeft, a.top - b.top - c.clientTop];
    }
    /* 受信の吹き出しが始まる列（受信の行の中でいちばん右の本文の左端）。
       アイコンを出さない全幅のカードがあっても、点がアイコンの列に寄らないように */
    function column() {
      if (colX !== null) return colX;
      var x = -1;
      rows.forEach(function (r) {
        if (kind(r) !== 'in' || !o.body) return;
        var b = r.querySelector(o.body);
        if (b && b.offsetParent) x = Math.max(x, offsetIn(b)[0]);
      });
      return (colX = x);
    }
    /* 「入力中…」を出しておく長さ（文字数に応じて。読み上げ用の「神戸リボン：」は数えない。
       連続メッセージは短め、行ごとに少しだけ揺らす） */
    function typeMs(r) {
      var i = rows.indexOf(r), m = o.meta ? r.querySelector(o.meta) : null, a = anchor(r);
      var chars = a === r || txt(a) - srLen(a) > 0 ? txt(r) - txt(m) - srLen(r) : 30;
      if (chars <= 0) chars = 30;
      var ms = clamp(chars * o.typePerChar, o.typeMin, o.typeMax) * (cont(r) ? o.contFactor : 1) *
        (1 + o.jitter * (((i * 37) % 21 - 10) / 10));
      return Math.max(o.typeMin * 0.85, ms);
    }
    function dropTyping(fast) {
      var t = typing; typing = null;
      if (t) {
        if (fast) t.remove();
        else {
          /* 点はすぐ消し、写したアイコンは行のアイコンが出てくるまで残す */
          if (t.firstChild) t.firstChild.setAttribute(TYP, 'out');
          setTimeout(function () { t.remove(); }, Math.max(160, o.dur));
        }
      }
      if (fast) { var left = c.querySelectorAll(':scope > .lchat-typing'); for (var i = 0; i < left.length; i++) left[i].remove(); }
    }
    function showTyping(r) {
      dropTyping(true);
      var list = /^(OL|UL)$/.test(c.tagName);
      var w = D.createElement(list ? 'li' : 'span'), b = D.createElement('span');
      colX = null; /* 列は毎回測り直す（画面を回した・幅が変わったあとも、点が吹き出しの列にそろう） */
      var p = offsetIn(anchor(r)), x = column();
      w.className = 'lchat-typing';
      w.setAttribute('aria-hidden', 'true');
      /* 位置はインラインで絶対配置・大きさ 0。CSS がなくても、まわりの行を押しのけない */
      css(w, { position: 'absolute', left: '0', top: '0', width: '0', height: '0', margin: '0', padding: '0',
        listStyle: 'none', pointerEvents: 'none', zIndex: '1' });
      b.className = 'lchat-typing__b';
      for (var i = 0; i < 3; i++) b.appendChild(D.createElement('i'));
      css(b, { position: 'absolute', margin: '0', top: p[1] + 'px', left: (x >= 0 ? x : p[0]) + 'px' });
      w.appendChild(b);
      var av = o.avatar && !cont(r) ? r.querySelector(o.avatar) : null;
      if (av && av.offsetParent) {
        var q = offsetIn(av), cl = av.cloneNode(true);
        cl.classList.add('lchat-typing__av');
        cl.removeAttribute('id');
        css(cl, { position: 'absolute', margin: '0', top: q[1] + 'px', left: q[0] + 'px' });
        w.appendChild(cl);
      }
      c.appendChild(w);
      typing = w;
    }
    function reveal(r) {
      if (pending(r)) r.setAttribute(ROW, 'shown');
      if (io) io.unobserve(r);
      if (io2) io2.unobserve(r);
      if (edgeT.has(r)) { clearTimeout(edgeT.get(r)); edgeT.delete(r); }
    }
    /* 行だけ表示していない（トークは見えている）か、トーク自身の枠（overflow）で切れて見えない行 */
    function unseeable(b) {
      var cb = c.getBoundingClientRect();
      if (!boxed(b)) return boxed(cb);
      return clips && (b.bottom <= cb.top + 1 || b.top >= cb.bottom - 1);
    }
    function seenPending() {
      if (tall) return false; /* 画面より高いトークは、見えた行それぞれに期限があるので不要 */
      var n = 0, late = false;
      for (var i = qi; i < rows.length; i++) if (pending(rows[i]) && seen.has(rows[i])) { n++; if (due.has(rows[i])) late = true; }
      return n > 2 && late;
    }
    function deadline(r, t) { due.set(r, Math.min(due.get(r) || Infinity, t)); }

    function pump() {
      while (!dead && active && !busy && !held) {
        if (gone()) { quit(); return; }
        while (qi < rows.length && !pending(rows[qi])) qi++;
        if (qi >= rows.length) { finish(); return; }
        if (shut()) { idle = true; return; }
        var r = rows[qi], b = r.getBoundingClientRect(), t = now();
        if (unseeable(b)) { reveal(r); qi++; continue; }
        if (!o.immediate && boxed(b) && b.bottom < 0) { passed(); return; }
        if (!seen.has(r)) { idle = true; return; }
        var first = idle;
        if (idle) { idle = false; runStart = t; startCap(); }
        /* 期限が来た行（とその前の行）: 点を出さずに、catchStepMs ずつ 1 行ずつ出す */
        if (qi <= catchTo || (!first && ((due.get(r) || Infinity) <= t || seenPending()))) {
          busy = true; catching = true;
          reveal(r);
          step(o.catchStepMs, next);
          return;
        }
        var lead = first && !started ? o.startDelay : 0, kd = kind(r);
        started = true;
        busy = true;
        /* 「入力中…」は受信のひとまとまりの最初の 1 通だけ（続きの吹き出しは、少し間をあけて出す） */
        if (kd === 'in' && !cont(r)) typeThenShow(r, lead);
        else {
          var gap = kd === 'out' ? (first ? 0 : cont(r) ? o.gapOutCont : o.gapOut) : kd === 'in' ? o.gapInCont : o.gapPlain;
          step(lead + gap, function () { reveal(r); step(o.dur, next); });
        }
        return;
      }
    }
    function typeThenShow(r, lead) {
      var wait = typeMs(r);
      step(lead + o.readPause, function () {
        /* 期限まで短くて「入力中…」が不自然になるときは、そのまま出す */
        var left = (due.get(r) || Infinity) - now();
        if (left < o.typeMin * 0.8) { reveal(r); step(o.dur, next); return; }
        showTyping(r);
        step(Math.min(wait, left), function () { dropTyping(false); reveal(r); step(o.dur, next); });
      });
    }
    function next() { busy = false; catching = false; qi++; pump(); }
    function interrupt() { gen++; clearTimeout(stepT); busy = false; catching = false; dropTyping(false); }

    /* 1 回の再生は runCapMs まで（5 秒を超えて動き続けない）。過ぎたら、見えている行を全部出して止まる。
       TOP の切り替え（immediate）は、セクションに一時停止のボタンがあるのでかけない */
    function startCap() {
      clearTimeout(capT); capT = 0;
      if (!o.immediate && o.runCapMs > 0) capT = setTimeout(capRun, o.runCapMs);
    }
    function capRun() {
      capT = 0;
      if (dead || !active || held) return;
      var last = -1, i;
      for (i = qi; i < rows.length; i++) {
        if (!seen.has(rows[i])) break;
        if (pending(rows[i])) last = i;
      }
      if (last < 0) return;
      interrupt();
      for (i = qi; i <= last; i++) reveal(rows[i]);
      qi = last + 1;
      idle = true; /* 次に見えた行からは、あらためて 1 通ずつ */
      pump(); armDue();
    }

    /* 上へ通り過ぎた行はすぐ出し、画面に残っている行には catchUpMs の期限を付ける */
    function passed() {
      interrupt();
      var last = -1, i;
      for (i = qi; i < rows.length; i++) {
        var b = rows[i].getBoundingClientRect();
        if (boxed(b) && b.bottom < 0) last = i;
      }
      for (i = qi; i <= last; i++) reveal(rows[i]);
      qi = Math.max(qi, last + 1);
      hurry = now() + o.catchUpMs;
      for (i = qi; i < rows.length; i++) if (seen.has(rows[i])) deadline(rows[i], hurry);
      idle = true;
      pump();
      armDue();
    }
    /* 期限が来た行は、その前の行も含めて出す（順番は崩さない）。いっぺんには出さず、pump が catchStepMs ずつ 1 行ずつ */
    function flush() {
      if (dead || !active) return;
      var t = now() + 16, last = -1, i;
      for (i = qi; i < rows.length; i++) {
        if (!seen.has(rows[i])) break;
        if (pending(rows[i]) && (due.get(rows[i]) || Infinity) <= t) last = i;
      }
      if (last > catchTo) {
        catchTo = last;
        if (!catching) { interrupt(); pump(); }
      }
      armDue();
    }
    function armDue() {
      clearTimeout(dueT);
      if (!active) return;
      var m = Infinity;
      for (var i = Math.max(qi, catchTo + 1); i < rows.length; i++) if (pending(rows[i]) && due.has(rows[i])) m = Math.min(m, due.get(rows[i]));
      if (m < Infinity) dueT = setTimeout(flush, Math.max(0, m - now()));
    }
    function see(r, t, k) {
      seen.set(r, t);
      /* 画面より高いトーク: 見えた行すべてに短い期限（画面ほどの空白が残らない）。
         同時に見えた行は tallStepMs ずつずらして、最初の画面も会話として読めるように */
      if (tall) deadline(r, t + o.maxWaitMs + (k || 0) * o.tallStepMs);
      else if (!idle) {
        if (hurry > t) deadline(r, hurry);
        else if (t > runStart + o.batchMs) deadline(r, t + o.catchUpMs);
      }
    }
    function onIO(entries) {
      if (dead || !active) return;
      if (gone()) { quit(); return; }
      var t = now(), past = false, fresh = [];
      entries.forEach(function (e) {
        var r = e.target, b = e.boundingClientRect;
        if (!pending(r)) { io.unobserve(r); return; }
        if (e.isIntersecting) { if (!seen.has(r)) fresh.push(r); }
        else if (boxed(b) && b.bottom < 0) past = true;
      });
      fresh.sort(function (a, b) { return rows.indexOf(a) - rows.indexOf(b); });
      fresh.forEach(function (r, i) { see(r, t, i); });
      if (past) passed(); else { pump(); armDue(); }
    }
    /* 主の監視が外している画面の下の帯（それ以上スクロールできないページの終わりなど）:
       そこに edgeMs いた行は見えたことにして、順番に並べる。期限を付けるのは画面より高いトークだけで、
       すでに待っている行のあとへ tallStepMs ずつずらす（帯の行の期限で、その前の行までいっぺんに出さない） */
    function onEdge(entries) {
      if (dead || !active) return;
      entries.forEach(function (e) {
        var r = e.target;
        if (edgeT.has(r)) { clearTimeout(edgeT.get(r)); edgeT.delete(r); }
        if (!e.isIntersecting || !pending(r) || seen.has(r)) return;
        edgeT.set(r, setTimeout(function () {
          edgeT.delete(r);
          if (dead || !active || !pending(r) || seen.has(r) || shut()) return;
          var t = now();
          seen.set(r, t);
          if (tall) {
            var last = 0;
            for (var i = qi; i < rows.length; i++) if (pending(rows[i]) && due.has(rows[i])) last = Math.max(last, due.get(rows[i]));
            deadline(r, Math.max(t + o.maxWaitMs, last + o.tallStepMs));
          }
          pump(); armDue();
        }, tall ? 0 : o.edgeMs));
      });
    }
    function observe() {
      if (!io) io = new IntersectionObserver(onIO, { rootMargin: o.rootMargin });
      if (!io2) io2 = new IntersectionObserver(onEdge);
      rows.forEach(function (r) { if (pending(r)) { io.observe(r); io2.observe(r); } });
    }
    function measure() {
      var h = c.getBoundingClientRect().height, s = getComputedStyle(c);
      tall = !o.immediate && h > (W.innerHeight || 0) * o.tallRatio;
      clips = s.overflowY !== 'visible';
      colX = null;
      /* 書き手への注意: 高さを決めた画面に収まらず、下が切れている（lchat__talk--end は上を切る指定なので除く） */
      if (clips && !c._lchatWarned && c.clientHeight && c.scrollHeight > c.clientHeight + 1 &&
          !c.classList.contains('lchat__talk--end') && W.console) {
        c._lchatWarned = true;
        console.warn('LChat: talk is taller than its screen and is clipped; use lphone--auto or lchat__talk--end', c);
      }
    }
    function mark(list) {
      c.setAttribute(INSTANT, '');
      list.forEach(function (r) {
        r.setAttribute(ROW, 'pending');
        var m = o.meta ? r.querySelector(o.meta) : null;
        if (m) m.setAttribute(META, '');
      });
      void c.offsetHeight;
      c.removeAttribute(INSTANT);
      marked = true;
      if (!posSet && getComputedStyle(c).position === 'static') { posSet = true; c.style.position = 'relative'; }
    }
    /* 最後の行が出たら、動きが終わるのを待ってから属性を外し、onDone を知らせる */
    function finish() {
      if (endT) return;
      endT = setTimeout(function () { endT = 0; if (active) halt(true); }, Math.max(600, o.dur + 240));
    }
    function unwait() {
      if (!waiting) return;
      W.removeEventListener('scrollend', waiting.go);
      clearTimeout(waiting.t);
      waiting = null;
    }
    /* 止めて全部出す（属性を外す）。onDone はここでは決めない（halt / quit が決める） */
    function cleanup() {
      gen++;
      clearTimeout(stepT); clearTimeout(dueT); clearTimeout(endT); endT = 0;
      clearTimeout(capT); capT = 0; catching = false;
      edgeT.forEach(function (id) { clearTimeout(id); }); edgeT.clear();
      unwait();
      busy = false; active = false; held = false;
      dropTyping(true);
      if (io) io.disconnect();
      if (io2) io2.disconnect();
      track(false);
      if (!marked) return;
      marked = false;
      c.setAttribute(INSTANT, '');
      var list = c.querySelectorAll('[' + ROW + '], [' + META + ']');
      for (var i = 0; i < list.length; i++) { list[i].removeAttribute(ROW); list[i].removeAttribute(META); }
      void c.offsetHeight;
      c.removeAttribute(INSTANT);
      if (posSet) { posSet = false; c.style.position = ''; }
    }
    /* fire = true: この回を「出し終えた」として onDone を 1 回。false: 黙って止める（始め直し・destroy） */
    function halt(fire) {
      cleanup();
      if (!reported) { reported = true; if (fire) report(); }
    }
    function quit() { halt(false); }
    function revealAll() { if (active) halt(true); }
    /* タブが表に戻った: immediate で裏にいる間に呼ばれた再生を、ここから始める */
    function wake() {
      if (!held || D.hidden) return;
      held = false;
      pump();
    }
    /* 画面の向き・幅が変わった（ページ全体の resize から）: 測り直して、出ている「入力中…」を今の位置に置き直す */
    function relayout() {
      if (!active || dead) return;
      measure();
      if (typing && qi < rows.length && pending(rows[qi])) showTyping(rows[qi]);
    }
    /* この回を始める。later = true なら隠すだけにして、見え方を調べるのは呼んだ側（replay のスクロール後） */
    function begin(later) {
      halt(false);
      clearTimeout(doneT); doneT = 0; /* 前の回の知らせが残っていれば取り消す */
      rows = rowsOf(c); qi = 0; seen = new Map(); due = new Map();
      idle = true; started = false; hurry = 0; busy = false; catchTo = -1; catching = false;
      /* immediate の from: その前の行（日付・最初の質問など）は出したまま */
      if (o.immediate) qi = clamp(Math.floor(+o.from) || 0, 0, rows.length);
      if (qi >= rows.length) { report(); return; }
      measure();
      mark(rows.slice(qi));
      active = true; reported = false;
      track(true);
      if (o.immediate) {
        var t = now();
        rows.forEach(function (r) { seen.set(r, t); });
        held = !!D.hidden;
        pump();
      } else if (!later) observe();
    }
    /* もう一度再生。トークの頭が画面の上半分になければ、そこまでスクロールしてから
       （そうしないと画面より上の行がすぐ出てしまい、最後の数行しか再生されない）。immediate はスクロールしない */
    function replay() {
      if (dead) return;
      if (off(c)) { if (active) halt(true); else report(); return; }
      if (o.immediate) { begin(false); return; }
      var top = c.getBoundingClientRect().top;
      if (top >= 0 && top < (W.innerHeight || 0) * 0.5) { begin(false); return; }
      begin(true);
      if (!active) return;
      var done = false;
      function go() {
        if (done) return;
        done = true;
        unwait();
        if (active && !dead) observe();
      }
      waiting = { go: go, t: setTimeout(go, 900) };
      W.addEventListener('scrollend', go);
      try { c.scrollIntoView({ block: 'start', behavior: reduced() ? 'auto' : 'smooth' }); } catch (e) { c.scrollIntoView(true); }
    }

    /* --- 出来事 --- */
    function onFocus() { revealAll(); }
    function onToggle(e) {
      if (!active) return;
      if (!e.target.open) {
        /* 途中で閉じた: 止めて、見えた記録を消す（開き直したら続きから。点が古い位置に残らない） */
        interrupt();
        clearTimeout(dueT);
        clearTimeout(capT); capT = 0;
        edgeT.forEach(function (id) { clearTimeout(id); }); edgeT.clear();
        if (!o.immediate) for (var i = qi; i < rows.length; i++) { seen.delete(rows[i]); due.delete(rows[i]); }
        hurry = 0; catchTo = -1;
        idle = true;
        return;
      }
      if (shut()) return;
      measure();
      if (!o.immediate && io) {
        /* 監視し直して、今見えている行をあらためて知らせてもらう */
        rows.forEach(function (r) { io.unobserve(r); io2.unobserve(r); });
        observe();
      }
      pump(); armDue();
    }
    function onClick() { replay(); }
    /* トークをクリック・タップしたら、待たずに全部出す（動きを止める手段。読み終えたい人を待たせない） */
    function onTap() { revealAll(); }
    c.addEventListener('focusin', onFocus);
    c.addEventListener('click', onTap);
    for (var p = c.parentElement; p; p = p.parentElement) if (p.tagName === 'DETAILS') { p.addEventListener('toggle', onToggle); details.push(p); }
    if (c.id) {
      buttons = [].slice.call(D.querySelectorAll('button[data-lchat-replay="' + (W.CSS && CSS.escape ? CSS.escape(c.id) : c.id) + '"]'));
      buttons.forEach(function (b) { b.hidden = false; b.addEventListener('click', onClick); });
    }

    ctl = {
      replay: replay,
      revealAll: revealAll,
      destroy: function () {
        if (dead) return;
        dead = true;
        reported = true;
        clearTimeout(doneT);
        cleanup();
        c.removeEventListener('focusin', onFocus);
        c.removeEventListener('click', onTap);
        details.forEach(function (d) { d.removeEventListener('toggle', onToggle); });
        buttons.forEach(function (b) { b.removeEventListener('click', onClick); b.hidden = true; });
        if (c._lchat === ctl) c._lchat = null;
      }
    };
    c._lchat = ctl;

    if (o.immediate) { begin(false); return ctl; }

    /* --- 最初の 1 回: 位置をまとめて読み、画面より下の最初の行（または表示していない行）から後ろだけを隠す --- */
    rows = rowsOf(c);
    var vb = viewBottom(), shown = boxed(c.getBoundingClientRect()), from = -1;
    var rects = rows.map(function (r) { return r.getBoundingClientRect(); });
    for (var i = 0; i < rows.length; i++) {
      var b = rects[i];
      if (!boxed(b)) { if (shown) continue; from = i; break; } /* 閉じた <details> の中など */
      if (b.top >= vb) { from = i; break; }
    }
    if (from < 0) { report(); return ctl; } /* 全部見えている: 何も隠さない */
    measure();
    mark(rows.slice(from));
    qi = from;
    active = true; reported = false;
    track(true);
    observe();
    return ctl;
  }

  function autoInit(root) {
    var list = (root || D).querySelectorAll('[data-lchat-auto]');
    for (var i = 0; i < list.length; i++) {
      var name = list[i].getAttribute('data-lchat-auto');
      play(list[i], Object.prototype.hasOwnProperty.call(PRESETS, name) ? PRESETS[name] : PRESETS.v9);
    }
  }

  W.LChat = { play: play, presets: PRESETS, defaults: DEFAULTS, autoInit: autoInit, viewBottom: viewBottom, restored: restored, version: '1.3.0' };
  function boot() { if (!restored()) autoInit(); }
  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
